<template>
  <div class="weekly-default-section w-100 position-relative">
    <!-- DEFAULT BODY -->
    <WeeklyDefaultRow :is_loading="loading" />
    <WeeklyDefaultRow :is_loading="loading" />
    <WeeklyDefaultRow :is_loading="loading" />
    <WeeklyDefaultRow :is_loading="loading" />
    <WeeklyDefaultRow :is_loading="loading" />
    <!-- DEFAULT BODY -->

    <EmptyContent
      display_img="HugoListEmpty.png"
      display_color=""
      header_title="No Activity Found"
      display_text="There are no activities of this type scheduled in your school this week. Make sure you have added your teacher and that they are using the app as they should. "
      button_type="emit"
      button_text="Create Event"
      button_function
      button_route_name
      :show_no_bg="true"
      :show_button="false"
      :show_empty="is_empty"
    ></EmptyContent>
  </div>
</template>

<script>
import WeeklyDefaultRow from "@/components/schoolComps/dashboard/home/WeeklyDefaultRow";

export default {
  name: "WeeklyDefaultSection",

  components: {
    WeeklyDefaultRow,
    EmptyContent: () =>
      import(
        /* webpack ChunkName: "defaulttask" */ "@/components/globalComps/EmptyContent"
      ),
  },

  props: {
    is_empty: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.weekly-default-section {
  margin-bottom: 100px;
  @include breakpoint_max(md) {
    margin-bottom: 120px;
  }
}
</style>